import useViewModel from "../../../viewModel";
import { Enums } from "../../../../../utils";
import Phone from "./phone";
import Ajax from "./ajax";

const Edit = ({ onDone = async () => {}, ...props }) => {
  const { alarmModel, addAlarmModel } = useViewModel();
  const alarm = props.alarm || alarmModel;

  const onDoneConfig = async (identifier) => {
    try {
      await addAlarmModel({ type: alarm.uuid, identifier });
      await onDone();
    } catch (error) {}
  };

  if (alarm?.integration === Enums.deviceIntegrations.ajax)
    return <Ajax alarmModel={alarmModel} onDone={onDoneConfig} />;
  else if (alarm?.integration === Enums.deviceIntegrations.sms)
    return <Phone onDone={onDoneConfig} />;
  return null;
};

export default Edit;
